var Currency = {
    rates: {
        USD: 1,
        EUR: 1.17157,
        GBP: 1.35029,
        CAD: .722857,
        ARS: 732922e-9,
        AUD: .655468,
        BRL: .183876,
        CLP: .00103639,
        CNY: .140105,
        CYP: .397899,
        CZK: .0480523,
        DKK: .156962,
        EEK: .0706676,
        HKD: .128263,
        HUF: .00298207,
        ISK: .00819218,
        INR: .0113355,
        JMD: .00624207,
        JPY: .00678556,
        LVL: 1.57329,
        LTL: .320236,
        MTL: .293496,
        MXN: .0534215,
        NZD: .589309,
        NOK: .0995507,
        PLN: .275747,
        SGD: .778089,
        SKK: 21.5517,
        SIT: 175.439,
        ZAR: .0568894,
        KRW: 721003e-9,
        SEK: .106582,
        CHF: 1.2526,
        TWD: .0327836,
        UYU: .0249858,
        MYR: .236674,
        BSD: 1,
        CRC: .00197355,
        RON: .230871,
        PHP: .01764,
        AED: .272294,
        VEB: 65176e-15,
        IDR: 609383e-10,
        TRY: .0242334,
        THB: .0311312,
        TTD: .148227,
        ILS: .300205,
        SYP: 769112e-10,
        XCD: .37021,
        COP: 252613e-9,
        RUB: .0122844,
        HRK: .155494,
        KZT: .00186076,
        TZS: 402391e-9,
        XPT: 1377.48,
        SAR: .266667,
        NIO: .0271932,
        LAK: 461361e-10,
        OMR: 2.5991,
        AMD: .00261246,
        CDF: 346159e-9,
        KPW: .00111115,
        SPL: 6,
        KES: .00773554,
        ZWD: .00276319,
        KHR: 249784e-9,
        MVR: .0649256,
        GTQ: .130527,
        BZD: .495854,
        BYR: 29593e-9,
        LYD: .184247,
        DZD: .00769835,
        BIF: 338852e-9,
        GIP: 1.35029,
        BOB: .144549,
        XOF: .00178605,
        STD: 473849e-10,
        NGN: 654642e-9,
        PGK: .24061,
        ERN: .0666667,
        MWK: 575992e-9,
        CUP: .0416965,
        GMD: .0137437,
        CVE: .0106245,
        BTN: .0113355,
        XAF: .00178605,
        UGX: 284857e-9,
        MAD: .110173,
        MNT: 278236e-9,
        LSL: .0568894,
        XAG: 41.0102,
        TOP: .426954,
        SHP: 1.35029,
        RSD: .0100028,
        HTG: .0076154,
        MGA: 223729e-9,
        MZN: .0156548,
        FKP: 1.35029,
        BWP: .0728763,
        HNL: .0383105,
        PYG: 138647e-9,
        JEP: 1.35029,
        EGP: .0205883,
        LBP: 110891e-10,
        ANG: .556378,
        WST: .360301,
        TVD: .655468,
        GYD: .00478202,
        GGP: 1.35029,
        NPR: .00708139,
        KMF: .00238139,
        IRR: 238045e-10,
        XPD: 1110.99,
        SRD: .0257344,
        TMM: 570969e-10,
        SZL: .0568894,
        MOP: .124527,
        BMD: 1,
        XPF: .00981775,
        ETB: .00701257,
        JOD: 1.41044,
        MDL: .0599051,
        MRO: .00250424,
        YER: .00416604,
        BAM: .599014,
        AWG: .558659,
        PEN: .283963,
        VEF: 65176e-12,
        SLL: 431701e-10,
        KYD: 1.2164,
        AOA: .00109474,
        TND: .34482,
        TJS: .106213,
        SCR: .0686181,
        LKR: .00331196,
        DJF: .00560346,
        GNF: 115335e-9,
        VUV: .00827842,
        SDG: .00166671,
        IMP: 1.35029,
        GEL: .371313,
        FJD: .443917,
        DOP: .015776,
        XDR: 1.36911,
        MUR: .0216929,
        MMK: 476232e-9,
        LRD: .00498054,
        BBD: .5,
        ZMK: 417734e-10,
        XAU: 3586.66,
        VND: 378931e-10,
        UAH: .0242103,
        TMT: .285485,
        IQD: 762994e-9,
        BGN: .599014,
        KGS: .0114347,
        RWF: 691127e-9,
        BHD: 2.65957,
        UZS: 803246e-10,
        PKR: .00352415,
        MKD: .019009,
        AFN: .0145719,
        NAD: .0568894,
        BDT: .00820895,
        AZN: .588235,
        SOS: .00175008,
        QAR: .274725,
        PAB: 1,
        CUC: 1,
        SVC: .114286,
        SBD: .120919,
        ALL: .012048,
        BND: .778089,
        KWD: 3.27217,
        GHS: .0827726,
        ZMW: .0417734,
        XBT: 110051,
        NTD: .0337206,
        BYN: .29593,
        CNH: .140298,
        MRU: .0250424,
        STN: .0473849,
        VES: .0065176,
        MXV: .457183,
        VED: .0065176,
        SLE: .0431701,
        XCG: .556378
    },
    convert: function(amount, from, to) {
        return amount * this.rates[from] / this.rates[to]
    }
};
//# sourceMappingURL=/cdn/s/javascripts/currencies.js.map